
type BreadcrumbItem = {
  label: string;
  href: string;
};
const styles: Record<string, React.CSSProperties> = {
  nav: {
    width: "100%",
    overflowX: "auto",
    whiteSpace: "nowrap",
    WebkitOverflowScrolling: "touch",
    color: "blue",
  },
  list: {
    display: "flex",
    alignItems: "center",
    listStyle: "none",
    padding: "4px 0",
    margin: 0,
    fontSize: "14px",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Inter, sans-serif",
  },
  item: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    padding: "10px",
  },
  link: {
    color: "#007bff", // blue
    textDecoration: "none",
    transition: "color 0.15s ease",
  },
  current: {
    color: "#111827", // near-black
    fontWeight: 600,
    letterSpacing: "0.01em",
  },
  separator: {
    margin: "0 10px",
    color: "#D1D5DB", // soft gray
    userSelect: "none",
  },
};
const Breadcrumbs = ({ items }: { items: BreadcrumbItem[] }) => {
  return (
    <nav aria-label="Breadcrumb" style={styles.nav}>
      <ol style={styles.list}>
        {items.map((item, index) => (
          <li key={item.label} style={styles.item}>
            {index < items.length - 1 ? (
              <a href={item.href} style={styles.link}>
                {item.label}
              </a>
            ) : (
              <span style={styles.current}>{item.label}</span>
            )}
            {index < items.length - 1 && (
              <span style={styles.separator}>›</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;